export default "__VITE_ASSET__CNg7PUTj__"